import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import { ApplicationExportTable, ApplicationExportPagination } from '../components';

export function DesktopLayout() {
  return (
    <Flex p={10} gap={8} direction="column">
      <PageHeader title="Data Export" />
      <ApplicationExportTable />
      <ApplicationExportPagination />
    </Flex>
  );
}
